
import Ace from "@/components/helpers/ace.vue"
import { Vue, Component, Watch } from "vue-property-decorator";
import ObjectDataTable from "@/components/helpers/object-data-table.vue";
import {
  mdiDotsVertical,
  mdiFolder,
  mdiFolderOpen,
  mdiMagnify,
  mdiMinus,
  mdiPen,
  mdiPlus,
  mdiPlusCircleOutline,
  mdiTrashCan,
} from "@mdi/js";
import editor from "./editor";

@Component({
  mixins: [editor],
  components: { ObjectDataTable, Ace },
})
export default class ProductLinkInlineEditor extends Vue {
  tab = null
  dialog = false;
  icons: any = {
    plus: mdiPlus,
    minus: mdiMinus,
    pen: mdiPen,
    trash: mdiTrashCan,
    search: mdiMagnify,
    dotsVertical: mdiDotsVertical,
    circlePlus: mdiPlusCircleOutline,
    folderOpen: mdiFolderOpen,
    folder: mdiFolder,
  };

  strValue: string = "";
  value: any;

  @Watch("strValue", { immediate: true, deep: true })
  onValueChange(newValue: any) {
    try{
      this.value = JSON.parse(newValue);
    } catch (e) {
    }
  }


  mounted() {
    this.strValue = JSON.stringify(this.value, null, 2);
  }
}
